import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SpinnerService {
  private loadingCount = 0;
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private showTimer: any = null;
  private readonly SHOW_DELAY = 160; // ms - don't show spinner for very short requests

  isLoading = this.loadingSubject.asObservable();

  // Backwards-compatible toggle
  toggleLoading(show: boolean) {
    if (show) this.requestStarted(); else this.requestFinished();
  }

  // Call when a request starts. The spinner will only be shown if the
  // request lasts longer than SHOW_DELAY to avoid flicker from many quick calls.
  requestStarted() {
    this.loadingCount++;
    if (this.loadingCount === 1) {
      // schedule showing the spinner after a short delay
      this.showTimer = setTimeout(() => {
        this.loadingSubject.next(true);
        this.showTimer = null;
      }, this.SHOW_DELAY);
    }
  }

  // Call when a request finishes.
  requestFinished() {
    this.loadingCount = Math.max(this.loadingCount - 1, 0);
    if (this.loadingCount === 0) {
      // if spinner wasn't shown yet, cancel scheduled show
      if (this.showTimer) {
        clearTimeout(this.showTimer);
        this.showTimer = null;
      }
      this.loadingSubject.next(false);
    }
  }
}
